class Accordion extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.isMobile = false;
  }

  connectedCallback() {
    this.header = this.querySelector('.accordion-header');
    this.content = this.querySelector('.accordion-content');
    this.icon = this.querySelector('.header-icon');

    // Initialize mobile state
    this.isMobile = window.innerWidth <= 768;

    // Set initial state based on mobile/desktop
    if (this.getAttribute('data-mobile-only') === 'true') {
      if (!this.isMobile) {
        this.content.style.maxHeight = 'none';
        this.content.style.opacity = '1';
        this.content.style.overflow = 'visible';
      } else {
        this.setupMobileState();
      }
    } else {
      this.setupMobileState();
    }

    // Add mobile-only behavior
    if (this.getAttribute('data-mobile-only') === 'true') {
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    this.header.addEventListener('click', () => {
      // Only toggle if not mobile-only OR if mobile-only and on mobile
      if (this.getAttribute('data-mobile-only') !== 'true' || this.isMobile) {
        this.toggleAccordion();
      }
    });
  }

  setupMobileState() {
    // Check for the data-open attribute to start open
    if (this.getAttribute('data-open') === 'true') {
      this.openAccordion(true);
    } else {
      this.icon.classList.add('icon-plus');
      this.content.style.maxHeight = '0px';
      this.content.style.overflow = 'hidden';
      this.content.style.transition = 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out';
    }
  }

  handleResize() {
    if (this.getAttribute('data-mobile-only') === 'true') {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      // Only update if mobile state changed
      if (wasMobile !== this.isMobile) {
        if (this.isMobile) {
          this.setupMobileState();
        } else {
          this.content.style.maxHeight = 'none';
          this.content.style.opacity = '1';
          this.content.style.overflow = 'visible';
        }
      }
    }
  }

  toggleAccordion() {
    if (this.isOpen) {
      this.closeAccordion();
    } else {
      this.closeOtherAccordions();
      this.openAccordion();
    }
  }

  openAccordion(initialLoad = false) {
    this.isOpen = true;
    // Replace icon class toggling with path visibility toggling
    this.querySelectorAll('.icon-plus-path').forEach((path) => path.classList.add('tw-hidden'));
    this.querySelector('.icon-minus-path').classList.remove('tw-hidden');
    this.content.classList.remove('tw-hidden');
    this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    this.content.style.opacity = '1';

    if (!initialLoad) {
      this.closeOtherAccordions();
    }
  }

  closeAccordion() {
    this.isOpen = false;
    // Replace icon class toggling with path visibility toggling
    this.querySelectorAll('.icon-plus-path').forEach((path) => path.classList.remove('tw-hidden'));
    this.querySelector('.icon-minus-path').classList.add('tw-hidden');
    this.content.style.maxHeight = '0px';
    this.content.style.opacity = '0';
  }

  closeOtherAccordions() {
    const accordionGroup = this.closest('.accordion-group');
    const otherAccordions = accordionGroup ? accordionGroup.querySelectorAll('accordion-component') : [];

    otherAccordions.forEach((accordion) => {
      if (accordion !== this && accordion.isOpen) {
        accordion.closeAccordion();
      }
    });
  }
}

customElements.define('accordion-component', Accordion);
